import React from "react";
import { IonCardContent, IonGrid } from "@ionic/react";

import styles from "./MainPageProduct.module.scss";
import classNames from "classnames/bind";
import BasketIcon from "./BasketIcon";
import { Product } from "@core/types";
import { useCartData } from "../../../../../providers/cartDataStore";
import QuantityCounter from "./QuantityCounter";

interface CardContentProps {
  product: Product;
}

const cx = classNames.bind(styles);

const CardContent = ({ product }: CardContentProps) => {
  const { cartProductsMap } = useCartData();
  const cartQuantity = cartProductsMap[product.id]?.quantity ?? 0;

  return (
    <IonCardContent className={cx("ion-no-padding", "product")}>
      <IonGrid
        className={cx(
          "ion-no-padding ion-padding-horizontal ion-padding-top",
          "flex items-center justify-center",
          styles.cardContent
        )}
      >
        {!cartQuantity ? <BasketIcon product={product} /> : <QuantityCounter product={product} />}
      </IonGrid>
    </IonCardContent>
  );
};

export default CardContent;
